import React, { FC, ChangeEvent } from 'react';

interface PowerAlarmProps {
  alarm: {
    type: string;
    name: string;
    group: string;
    powerDisconnected: boolean;
  };
  onChange: (updatedAlarm: PowerAlarmProps['alarm']) => void;
}

const PowerAlarm: FC<PowerAlarmProps> = ({ alarm, onChange }) => {
  const handleRadioChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value === 'disconnected';
    onChange({ ...alarm, powerDisconnected: value });
  };

  return (
    <div className="form-group">
      <label style={{ display: 'block', marginBottom: '8px' }}>
        Alimentation :
      </label>

      <div style={{ display: 'flex', gap: '20px' }}>
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '6px 12px',
            borderRadius: '5px',
            border: alarm.powerDisconnected === false ? '2px solid orange' : '1px solid #ccc',
            backgroundColor: alarm.powerDisconnected === false ? '#fff3e0' : '#fff',
            cursor: 'pointer'
          }}
        >
          <input
            type="radio"
            name="power"
            value="connected"
            checked={!alarm.powerDisconnected}
            onChange={handleRadioChange}
            style={{ accentColor: 'orange', marginRight: '6px' }}
          />
          Connectée
        </label>

        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '6px 12px',
            borderRadius: '5px',
            border: alarm.powerDisconnected === true ? '2px solid orange' : '1px solid #ccc',
            backgroundColor: alarm.powerDisconnected === true ? '#fff3e0' : '#fff',
            cursor: 'pointer'
          }}
        >
          <input
            type="radio"
            name="power"
            value="disconnected"
            checked={alarm.powerDisconnected}
            onChange={handleRadioChange}
            style={{ accentColor: 'orange', marginRight: '6px' }}
          />
          Déconnectée
        </label>
      </div>
    </div>
  );
};

export default PowerAlarm;
